







































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import RateEditDialog from './RateEditDialog.vue';
import RateAddDialog from './RateAddDialog.vue';
import { Building } from '@/modules/backend/Entities/Building';
import { RatesModule } from '@/store/dashboard/rates/RatesModule';
import { resolveModule } from '@/store';
import RatesResetDialog from '@/components/rates/RatesResetDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { Rate } from '@/modules/backend/Entities/Rate';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import { currency } from '@/filters/currency';

@Component({
  mixins: [Mixin],
  filters: {
    currency
  },
  components: {
    DataTableWrapper,
    'rate-edit-dialog': RateEditDialog,
    'rate-add-dialog': RateAddDialog,
    'rates-reset-dialog': RatesResetDialog
  }
})
export default class Rates extends Mixins(Mixin) {
  @Prop({
    required: false,
    default: '100%'
  })
  private readonly maxWidth: string | number = '100%';

  @Prop({ required: true, type: Building })
  private readonly building!: Building;

  private readonly ratesModule: RatesModule = resolveModule(RatesModule);

  private loading = false;

  private get rates(): Rate[] {
    return this.ratesModule.rates.sort((a, b): number => {
      if (a.removable === b.removable) {
        return b.getResource().getId() - a.getResource().getId();
      } else {
        return (b.removable) ? -1 : 1;
      }
    });
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id',
      },
      {
        text: this.$i18n.t('screens.rates.dialog_fields.name').toString(),
        value: 'resource.title'
      },
      {
        text: this.$i18n.t('screens.rates.dialog_fields.price').toString(),
        value: 'price'
      },
      {
        text: this.$i18n.t('common.table.headers.actions').toString(),
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ];
  }

  private loadingHandler(loadingState: boolean): void {
    this.loading = loadingState;
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await this.ratesModule.fetch(this.building.getId());
    this.loading = false;
  }

  @Watch('building', { immediate: true, deep: true })
  private async buildingChangedHandler(): Promise<void> {
    await this.loadData();
  }
}
